module.exports = __webpack_public_path__ + "images/erp-nation-glad-bottom.1787648603550.png";